module.exports = __webpack_public_path__ + "media/images/icon_chat-5b2641c72d1341a4a05625ee978f93a0.svg";